import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemEventsAddRoute: InvariantJiraRoute = {
	name: 'global-settings-system-events-add',
	path: '/secure/admin/AddEventType.jspa',
};
